import { Component, Prop, toNative } from "vue-facing-decorator";
import { BufferedBase } from "./BufferedBase";
import { type IItems } from "./IItems";

/*
 * The ids of items shown in a list.
 *
 * This is typically a list of UUIDs as stored in our database or just a
 * sequence of integers for static lists that are not backed by the database
 * entities.
 *
 * This class augments such a list of integers with buffering of the IBuffered
 * interface.
 */
@Component
export class BufferedItems<S> extends BufferedBase<S[]> {
	@Prop({ required: true, type: Object }) protected readonly items!: IItems<S>;

	public preload(index: number): Promise<void> {
		return this.items.load([index]);
	}

	protected getFromBackend(): S[] {
		return this.items.items;
	}

	protected loadInBackend(): Promise<void> {
		// Preload some items, typically, the first pages of content.
		return this.items.load([0]);
	}

	protected invalidateInBackend(): Promise<void> {
		return this.items.reset();
	}

	public get totalCountEstimate(): number {
		return this.items.totalCountEstimate;
	}

	protected isBackendResetting(): number {
		return this.items.isResetting;
	}
}

export default toNative(BufferedItems);
